import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbDateStruct, NgbDatepickerConfig, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';

import { CustomerInputService } from '../Services/customer-input.service';
import { MatchingService } from '../Services/matching.service';
import { Logininfo } from '../classes/Loginifo';

export class Request {
  name: string;
  kana: string;
  mail: string;
  tel: number;
  tel_mobile: number;
  contact_method: string;
  interview_place: string;
  content_inquiry: string;
  child_flag: string;

  reqdate1: { year: number, month: number, day: number };
  reqtime1: string;
  reqdate2: { year: number, month: number, day: number };
  reqtime2: string;
  reqdate3: { year: number, month: number, day: number };
  reqtime3: string;
}


@Component({
  selector: 'app-web-request',
  templateUrl: './web-request.component.html',
  styleUrls: ['./web-request.component.css']
})
export class WebRequestComponent implements OnInit {
  readonly INPUT: number = 0;
  readonly CONFIRM: number = 1;
  readonly COMPLETED: number = 2;
  model: NgbDateStruct;
  request: Request = {
    name: '',
    kana: '',
    mail: '',
    tel: null,
    tel_mobile: null,
    contact_method: "1",
    interview_place: '',
    content_inquiry: '',
    child_flag: '',
    reqdate1: null,   //{year: null, month: null, day: null},
    reqtime1: '',
    reqdate2: null,   //{year: null, month: null, day: null},
    reqtime2: '',
    reqdate3: null,    //{year: null, month: null, day: null},
    reqtime3: '',
  };
  progress: number;
  place_list: any;

  requestForm: FormGroup;

  constructor(config: NgbDatepickerConfig,
    calendar: NgbCalendar,
    public customerInputService: CustomerInputService,
    private matchS: MatchingService,
  ) {
    config.minDate = { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 };
  }

  ngOnInit() {
    this.progress = this.INPUT;
    this.requestForm = new FormGroup({
      'name': new FormControl(this.request.name, [
        Validators.required,
        Validators.maxLength(20)
      ]),
      'kana': new FormControl(this.request.kana, [
        Validators.required,
        Validators.maxLength(30)
      ]),
      'mail': new FormControl(this.request.mail, [
        Validators.required,
        Validators.email,
        Validators.maxLength(50)
      ]),
      'tel': new FormControl(this.request.tel, [
        Validators.required,
        Validators.maxLength(20)
      ]),
      'tel_mobile': new FormControl(this.request.tel_mobile, [
        Validators.required,
        Validators.maxLength(20)
      ]),
      'contact_method': new FormControl(this.request.contact_method, [
      ]),
      'interview_place': new FormControl(this.request.interview_place, [
        Validators.required,
      ]),
      'child_flag': new FormControl(this.request.child_flag, [
      ]),
      'content_inquiry': new FormControl(this.request.content_inquiry, [
      ]),

      'reqdate1': new FormControl(this.request.reqdate1, [
        Validators.required,
      ]),
      'reqtime1': new FormControl(this.request.reqtime1, [
        Validators.required,
      ]),
      'reqdate2': new FormControl(this.request.reqdate2, [
        Validators.required,
      ]),
      'reqtime2': new FormControl(this.request.reqtime2, [
        Validators.required,
      ]),
      'reqdate3': new FormControl(this.request.reqdate3, [
        //Validators.required,
      ]),
      'reqtime3': new FormControl(this.request.reqtime3, [
        //Validators.required,
      ]),
    });

    //面談履歴：場所表示用
    let place_list = this.customerInputService.placeList(0);
    place_list.subscribe(place_list => {
      this.place_list = place_list;
    });
  }

  onSubmit() {
    this.progress = this.CONFIRM;
  }

  cancel() {
    this.progress = this.INPUT;
  }

  send() {
    this.progress = this.COMPLETED;
  }
}
